module.exports = __webpack_public_path__ + "img/example.40da1217.jpg";